import React from 'react'
import './ResourceList.less'
import { useMutableArg } from 'front-end/src/app/hooks/useMutableArg'
import { ResourceListProps } from './ResourceList'

export const useSortableTopics = (
  notSortedResources: ResourceListProps['resources'],
  refetch: () => Promise<unknown>,
  rearrangeResources: ResourceListProps['rearrangeResources']
) => {
  const [resources, setResources] = useMutableArg(notSortedResources)
  const isRearrangeInProgress = React.useRef(false)
  const handleSortEnd = React.useCallback(
    async ({ newIndex, oldIndex }) => {
      if (newIndex === oldIndex || !resources || isRearrangeInProgress.current)
        return
      isRearrangeInProgress.current = true
      const resourcesCopy = [...resources]
      // optimistic UI, rearrange elements while request in progress
      resourcesCopy.splice(newIndex, 0, resourcesCopy.splice(oldIndex, 1)[0])
      setResources(resourcesCopy)

      // send request to GQL
      try {
        await rearrangeResources(resourcesCopy.map((t) => t.id!))
      } finally {
        await refetch()
        isRearrangeInProgress.current = false
      }
    },
    [resources]
  )

  return { resources, handleSortEnd }
}
